import { render, staticRenderFns } from "./ValidationProvider.vue?vue&type=template&id=61d68122"
import script from "./ValidationProvider.vue?vue&type=script&lang=js"
export * from "./ValidationProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports